


export class CJI3 {
  "companyCode";
  "fiscalYear";
  "period";
  "order";
  "coObjectName";
  "costElement";
  "costElementDescr";
  "name";
  "documentHeaderText";
  "valueInObjCrcy";
  "drCrIndicator";
  "userName";
  "documentDate";
  "documentNumber";
  "purchasingDocument";
  "purchaseOrderText";
  "item";
  "refDocumentNumber";
  "material";
  "partnerCCtr";
  "coPartnerObjectName";
  "fullName";
  "personnelNumber";
  "partnerObject";
  "parActivity";
  "valCoAreaCrcy";
  "totalQuantity";
  "createdOn";
  "coAreaCurrency";
  "postingRow";
  "postingDate";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CJI3`.
   */
  static getModelName() {
    return "CJI3";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CJI3 for dynamic purposes.
  **/
  static factory(data) {
    return new CJI3(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'CJI3',
      plural: 'CJI3s',
      path: 'CJI3s',
      properties: {
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "fiscalYear": {
          name: 'fiscalYear',
          type: 'string'
        },
        "period": {
          name: 'period',
          type: 'string'
        },
        "order": {
          name: 'order',
          type: 'string'
        },
        "coObjectName": {
          name: 'coObjectName',
          type: 'string'
        },
        "costElement": {
          name: 'costElement',
          type: 'string'
        },
        "costElementDescr": {
          name: 'costElementDescr',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "documentHeaderText": {
          name: 'documentHeaderText',
          type: 'string'
        },
        "valueInObjCrcy": {
          name: 'valueInObjCrcy',
          type: 'string'
        },
        "drCrIndicator": {
          name: 'drCrIndicator',
          type: 'string'
        },
        "userName": {
          name: 'userName',
          type: 'string'
        },
        "documentDate": {
          name: 'documentDate',
          type: 'string'
        },
        "documentNumber": {
          name: 'documentNumber',
          type: 'string'
        },
        "purchasingDocument": {
          name: 'purchasingDocument',
          type: 'string'
        },
        "purchaseOrderText": {
          name: 'purchaseOrderText',
          type: 'string'
        },
        "item": {
          name: 'item',
          type: 'string'
        },
        "refDocumentNumber": {
          name: 'refDocumentNumber',
          type: 'string'
        },
        "material": {
          name: 'material',
          type: 'string'
        },
        "partnerCCtr": {
          name: 'partnerCCtr',
          type: 'string'
        },
        "coPartnerObjectName": {
          name: 'coPartnerObjectName',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "personnelNumber": {
          name: 'personnelNumber',
          type: 'string'
        },
        "partnerObject": {
          name: 'partnerObject',
          type: 'string'
        },
        "parActivity": {
          name: 'parActivity',
          type: 'string'
        },
        "valCoAreaCrcy": {
          name: 'valCoAreaCrcy',
          type: 'string'
        },
        "totalQuantity": {
          name: 'totalQuantity',
          type: 'string'
        },
        "createdOn": {
          name: 'createdOn',
          type: 'string'
        },
        "coAreaCurrency": {
          name: 'coAreaCurrency',
          type: 'string'
        },
        "postingRow": {
          name: 'postingRow',
          type: 'string'
        },
        "postingDate": {
          name: 'postingDate',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/CJI3.js